// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getPageLinkByPageType, useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { ActiveState, Jsonld, SeoProps } from "@stoneage/App/Widgets/SearchEngineOptimization/SearchEngineOptimization";

/**
 * Activate structure based on condition
 *
 * @param SeoProps
 * @returns ActiveState
 */
const activate = ({ state, fields, payload }: SeoProps): ActiveState => {
    const contactUsUrl = getPageLinkByPageType(state, "ContactUsPage")?.url;
    payload.contactLink = contactUsUrl;
    return true;
};

/**
 * Build the structured data
 *
 * @param SeoProps
 * @returns Jsonld
 */
const json = ({ state, fields, payload, url }: SeoProps): Jsonld => {
    const link = useGetLink(fields.contactUs)?.url;
    const contactLink = link || (payload.contactLink ? payload.contactLink : "");
    const contactUrl = `${url}${contactLink}`;
    return {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        name: fields.organizationName || state.context.website.name,
        description: fields.description,
        url: contactUrl,
        image: fields.logoUrl,
    };
};

export default { activate, json };
